module.exports = __webpack_public_path__ + "bbe5c835992b514714cba461e09208a9.svg";